import {View} from '@ab/components';
import template from '../templates/itemDetails';
import category from '../utils/computeCategory.u';
import {CATEGORY_CREDIT_PERCENTS} from '../variables';
import {api, get} from '../../../config';
import mixins from '../../../mixins';

class ItemDetails extends View {
    template = template;

    state = {
        percent: false,
        isDisabledEmail: true,
        emailValue: get('EMAIL'),
        isShowModal: false,
        isShowErrorModal: false,
        showToast: false,
    };

    hadConverting(model) {
        return (
            model.account_amount.currency &&
            model.account_amount.currency !== model.amount_original.currency
        );
    }

    sendToEmail = async model => {
        try {
            this.setState({isShowModal: false});
            let action;
            if (model.category.id === 100000000000896) {
                action = 'depositProperty';
            }
            if (model.category.id === 100000000000895) {
                action = 'creditCards';
            }
            const response = await fetch(api('API_SEND_TO_EMAIL'), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
                body: JSON.stringify({
                    action,
                    cardId: this.props.card.id,
                    date: model.date,
                    email: this.state.emailValue.trim(),
                }),
            });
            const result = await response.json();
            if (result.status === 'success') {
                this.setState({showToast: true});
                setTimeout(() => {
                    this.setState({showToast: false});
                }, 3000);
            }
        } catch (err) {
            console.log(err);
        }
    };

    handleChangeEmail = ({target}) => {
        this.setState({emailValue: target.value});
        const isValidEmail = this.validateEmail(target.value);
        if (isValidEmail) {
            this.setState({isDisabledEmail: false});
        } else {
            this.setState({isDisabledEmail: true});
        }
    };

    validateEmail = email => {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    checkHintAttributes = (model, key) => {
        if (model.hasOwnProperty('hint_attributes')) {
            const hasAttr = Object.keys(model.hint_attributes).includes(key);
            return hasAttr;
        } else {
            return false;
        }
    };
    printInvoice = async model => {
        const response = await fetch(api('API_GET_RECEIPT_NEW'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({
                request_ref: mixins.requestRefUuid(),
                sid: mixins.getCookie('skey'),
                lang: get('LANG'),
                data: {
                    id_earch: model.archive_ref,
                },
            }),
        });
        const result = await response.json();
        window.open(result.data.doc_link, '_blank');
    };

    exchangeRate(model) {
        return model.rate.toFixed(3);
    }

    isPercentsByCredit(settings) {
        return category(this, settings) === CATEGORY_CREDIT_PERCENTS;
    }

    toggleCalculations = event => {
        event?.preventDefault();
        this.setState({percent: !this.state.percent});
    };

    handleCardSetting = params => {
        if (params.hash_pan && params.date_from) {
            this.changeCardSetting(params);
        }
    };

    async changeCardSetting({hash_pan, date_from}) {
        const response = await fetch(api('CHANGE_CARD_SETTING'), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
            body: JSON.stringify({
                lang: get('LANG'),
                request_ref: mixins.requestRefUuid(),
                sid: mixins.getCookie('skey'),
                data: {
                    action: 'accrued_interest',
                    date_from,
                    hash_pan,
                },
            }),
        });

        try {
            const res = await response.json();

            if (res.result === 'ok') {
                window.open(res.data.document, '_target');
            }

            if (res.result === 'error') {
                throw new Error(res.error.message);
            }
        } catch (error) {
            this.setState({isShowErrorModal: true});
        }
    }

    static displayName = 'Statements.Views.ItemDetails';
}

export default ItemDetails;
